import styled from "styled-components";

export const StyledTenantDetails = styled.section`
    .payments-wrapper {
        border: 1px solid var(--bllink-blue);
        box-sizing: border-box;
        border-radius: 50px;
        width: 100%;
        padding: 30px 50px;
        h4 {
            font-family: var(--bllink-font-headers);
            font-style: normal;
            font-weight: normal;
            font-size: 30px;
            line-height: 23px;
            text-align: center;
            color: var(--bllink-gray);
            padding: 24px;
        }
    }

    .form-main-block {
        display: flex;
        flex-direction: column;
        gap: 30px;

        .input-item {
            .label {
                width: 100%;
                text-align: start;
            }
        }
    }

    .bllink-input-border {
        height: 40px
    }

    .form-button {
        text-align: end;
    }
`
